export default __webpack_public_path__ + "static/vacations-preview-adventure-1-4b0c1170f184d8bbbff69e2b8410a225.jpg";